var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _g2, _path16, _g3, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 178,
    viewBox: "0 0 179 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_22369)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 0H0.5V178H178.5V0Z",
    fill: "#EDD4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.112 112.965C98.1449 114.745 86.3494 114.045 74.5658 112.413C90.2891 117.581 103.639 122.583 115.862 124.998C135.994 128.973 159.887 127.258 178.5 125.793V112.324C165.34 109.707 146.175 107.637 110.112 112.965Z",
    fill: "#4C073F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 124.997C103.657 122.583 90.2891 117.581 74.5658 112.413C54.5349 105.833 30.6591 98.9798 0.5 96.8676V126.101C115.334 118.667 119.558 145.367 178.5 149.722V125.787C159.887 127.258 135.994 128.973 115.862 124.997Z",
    fill: "#97406C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 125.899V177.798H178.5V149.52C119.558 145.165 115.334 118.465 0.5 125.899Z",
    fill: "#E0AEB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5271 31.2865C62.0075 31.288 61.4906 31.3598 60.9904 31.5001C59.919 29.4931 58.1077 27.9826 55.9409 27.2891C53.7741 26.5956 51.4223 26.7738 49.3848 27.7858C47.8167 26.1953 45.8115 25.1065 43.6237 24.6574C41.4358 24.2083 39.1639 24.4192 37.0961 25.2633C35.0283 26.1075 33.2578 27.5469 32.0093 29.3988C30.7608 31.2508 30.0906 33.4318 30.0836 35.6653C30.0836 35.8017 30.0836 35.9323 30.0836 36.0687H68.2409C67.997 34.7298 67.292 33.5184 66.2483 32.6449C65.2046 31.7714 63.8881 31.2908 62.5271 31.2865Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.435 62.6263C126.016 62.6261 125.598 62.684 125.195 62.7984C124.327 61.1779 122.863 59.9585 121.112 59.3982C119.362 58.8379 117.462 58.9806 115.814 59.7961C114.763 58.7173 113.46 57.9171 112.022 57.4676C110.584 57.0181 109.057 56.9334 107.578 57.2213C106.1 57.5091 104.716 58.1604 103.552 59.1164C102.388 60.0724 101.48 61.3031 100.91 62.6975C100.639 62.6498 100.366 62.626 100.091 62.6263C99.6717 62.6261 99.2543 62.684 98.8509 62.7984C97.996 63.032 97.2243 63.5024 96.625 64.1553C96.0256 64.8082 95.6228 65.6171 95.463 66.4889H131.063C130.866 65.4052 130.295 64.425 129.449 63.7192C128.603 63.0133 127.537 62.6266 126.435 62.6263Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.043 35.7483C132.536 35.7483 136.178 32.1117 136.178 27.6256C136.178 23.1395 132.536 19.5029 128.043 19.5029C123.55 19.5029 119.908 23.1395 119.908 27.6256C119.908 32.1117 123.55 35.7483 128.043 35.7483Z",
    fill: "#F1667C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.319 107.684C142.787 106.503 143.054 105.216 143.054 103.863C143.054 100.475 141.417 97.4729 138.901 95.5801C139.387 94.6308 139.66 93.5628 139.66 92.4236C139.66 88.5669 136.534 85.4401 132.671 85.4401C128.808 85.4401 125.681 88.5669 125.681 92.4236C125.681 93.5628 125.96 94.6308 126.441 95.5801C123.925 97.4729 122.288 100.469 122.288 103.863C122.288 105.151 122.531 106.373 122.958 107.512C120.97 109.767 119.76 112.722 119.76 115.961C119.76 123.022 125.492 128.742 132.558 128.742C139.625 128.742 145.356 123.016 145.356 115.961C145.368 112.799 144.217 109.915 142.319 107.684Z",
    fill: "#FF527D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.367 128.658H147.516V134.004H149.367V128.658Z",
    fill: "#F99BAA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.442 128.658H131.591V134.004H133.442V128.658Z",
    fill: "#F99BAA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155.983 129.275H140.657L148.454 106.675L155.983 129.275Z",
    fill: "#FF8CA2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2589_22369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -73,
    y: -123,
    width: 410,
    height: 307
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 -123H-72.5V183.75H336.5V-123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2589_22369)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 -123.532H-72.5V184.169H336.5V-123.532Z",
    fill: "#D7E2EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M269.148 38.1562H-74.7086V173.832H269.148V38.1562Z",
    fill: "#C6D6E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2589_22369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 30,
    width: 130,
    height: 10
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.68372 31.3054C7.98096 31.7655 37.3472 30.15 45.0159 30.15C52.6847 30.15 61.3145 30.0375 65.4659 30.7737C69.6172 31.5099 70.6909 30.0988 74.6684 30.7737C78.6459 31.4485 107.276 34.4649 107.276 34.4649L122.9 35.5897L126.366 36.5508C126.366 36.5508 125.344 38.2891 121.254 38.4731C104.392 39.2604 58.7481 39.6592 49.9239 39.3934C38.9832 39.0764 -2.66326 36.2338 -2.66326 36.2338L-2.68372 31.3054Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2589_22369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.366 28.4526H-2.68372V39.2604H126.366V28.4526Z",
    fill: "#25285F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M126.366 30.1806H-2.68372V40.9884H126.366V30.1806Z",
    fill: "#9ABBDD"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-70.7208 32.9823C-70.7208 32.9823 -51.1297 32.2564 -29.7084 30.3852C-13.4846 28.8255 2.85136 28.8255 19.0751 30.3852C31.3451 31.5713 58.8401 30.7431 73.8504 34.4036C88.8607 38.0642 124.106 35.5693 127.092 36.5202C130.078 37.4711 145.763 38.831 145.763 38.831C145.763 38.831 137.44 40.5488 121.683 39.9967C105.926 39.4445 81.7339 40.0989 81.7339 40.0989L-21.7022 41.9394H-70.7208V32.9823Z",
    fill: "#7C8AB6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2589_22369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -71,
    y: 29,
    width: 217,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.7208 32.9823C-70.7208 32.9823 -51.1297 32.2564 -29.7084 30.3852C-13.4846 28.8255 2.85136 28.8255 19.0751 30.3852C31.3451 31.5713 58.8401 30.7431 73.8504 34.4036C88.8607 38.0642 124.106 35.5693 127.092 36.5202C130.078 37.4711 145.763 38.831 145.763 38.831C145.763 38.831 137.44 40.5488 121.683 39.9967C105.926 39.4445 81.7339 40.0989 81.7339 40.0989L-21.7022 41.9394H-70.7208V32.9823Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2589_22369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.763 29.2195H-70.7208V43.4731H145.763V29.2195Z",
    fill: "#7C8AB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.763 28.4526H-70.7208V42.7063H145.763V28.4526Z",
    fill: "#7C8AB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2589_22369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -74,
    y: -101,
    width: 411,
    height: 285
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M336.132 -100.014H-73.1135V183.862H336.132V-100.014Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2589_22369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.2832 25.3954C-49.78 27.9824 -26.8044 27.9824 -6.65096 31.4384C13.5025 34.8945 43.3391 34.0356 50.609 35.7534C57.879 37.4712 83.5744 37.7984 87.2452 37.7984C90.916 37.7984 97.3782 40.3853 97.3782 40.3853C97.3782 40.3853 87.2043 41.5407 87.2452 42.6859C87.2861 43.8311 74.3924 44.7309 63.9118 45.2831C53.4311 45.8352 36.4985 46.7248 36.4985 48.4528C36.4985 50.1808 33.2777 53.3404 23.6048 53.6267C13.932 53.913 -10.6694 56.7964 -32.0294 58.2381C-53.3894 59.6799 -76.2832 59.3731 -76.2832 59.3731V25.3954Z",
    fill: "#A3C1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.991 46.96C336.991 46.96 294.915 18.6776 229.025 38.78C217.185 42.3894 182.368 73.9949 126.591 96.1115C106.591 104.036 74.6377 104.005 35.5885 116.47C8.49222 125.13 -3.79824 139.312 -39.6369 153.464C-83.2158 170.662 -91.6719 178.004 -90.4244 182.543C-89.6678 185.325 -86.089 187.574 -78.86 188.893C-49.0439 194.323 19.9749 193.229 50.5681 193.229C81.1613 193.229 336.674 192.615 336.674 192.615L336.991 46.96Z",
    fill: "#A3C1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.966 214.139C-37.735 224.65 -55.3936 234.108 -63.9519 238.863L-74.7904 193.198C-51.4979 180.406 -19.0437 165.846 36.4576 147.748C39.1468 146.868 95.0673 119.373 101.213 117.748C116.376 113.729 121.663 114.864 147.695 105.478C178.452 94.3528 201.581 82.5429 216.458 70.3752C242.379 49.189 245.538 42.8801 268.381 31.5202C269.884 31.7247 276.939 31.1009 279.833 31.3054L281.561 31.4179C281.561 31.4179 285.651 31.7349 289.741 32.3893C295.804 33.3402 297.348 33.3198 303.034 35.1091C282.113 45.5182 258.044 71.7658 233.8 91.592C224.311 99.3528 212.205 106.93 197.808 114.087C185.947 119.977 155.293 138.423 140.088 143.924C112.91 153.76 105.323 169.486 91.3556 177.574",
    fill: "#ACC6DE"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99739 175.396H-21.743L-7.62231 134.486L5.99739 175.396Z",
    fill: "#33A3DC"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 118.6H63.5C63.0584 118.6 62.7 118.242 62.7 117.8V82.6C62.7 82.1584 63.0584 81.8 63.5 81.8H115.5C115.942 81.8 116.3 82.1584 116.3 82.6V117.8C116.3 118.242 115.942 118.6 115.5 118.6ZM69.9 112.2H109.1C109.542 112.2 109.9 111.842 109.9 111.4V89C109.9 88.5584 109.542 88.2 109.1 88.2H69.9C69.4584 88.2 69.1 88.5584 69.1 89V111.4C69.1 111.842 69.4584 112.2 69.9 112.2Z",
    fill: "#2F3A71"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9001 106.153H87.1C86.6584 106.153 86.3 105.794 86.3 105.353V95.4C86.3 94.9584 86.6584 94.6 87.1 94.6H91.9001C92.3417 94.6 92.7001 94.9584 92.7001 95.4V105.353C92.7001 105.794 92.3417 106.153 91.9001 106.153Z",
    fill: "#2F3A71"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.079 78.5559H104.277C103.844 78.5559 103.502 78.2111 103.478 77.7791C103.074 70.4191 96.9583 64.5559 89.4999 64.5559C82.0415 64.5559 75.9255 70.4191 75.5215 77.7791C75.4975 78.2111 75.1559 78.5559 74.7231 78.5559H69.9207C69.4711 78.5559 69.0983 78.1839 69.1167 77.7343C69.5487 66.8655 78.5263 58.1559 89.4999 58.1559C100.474 58.1559 109.451 66.8655 109.884 77.7343C109.902 78.1839 109.53 78.5559 109.079 78.5559Z",
    fill: "#2F3A71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_22369"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 178,
    height: 178,
    rx: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/otp-icon.8b6af89d848e0b939b925e4c319c44c6.svg";
export { ForwardRef as ReactComponent };